export * from "./navigation/nav-service";
export * from "./navigation/toggle";
export * from "./navigation/directives";



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/core/navigation.ts